import DeleteIcon from '@mui/icons-material/Delete';
import { IconButton, Paper, Switch, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material';
import ConfirmationDialog from 'components/ConfirmationDialog/ConfirmationDialog';
import { useTranslation } from 'react-i18next';
import { DiscountCodeType } from 'types/discount-code.types';

import { usePriceFormatter } from '../../../../hooks/usePriceFormatter';

type DiscountCodesTableProps = {
  rows: any[];
  onStatusChange: (discountCode: DiscountCodeType) => void;
  onDelete: (discountCodeId: number) => void;
};

const DiscountCodesTable = (props: DiscountCodesTableProps) => {
  const { rows, onStatusChange, onDelete } = props;
  const { t } = useTranslation();
  const formatPrice = usePriceFormatter();

  // Don't show empty table if no vouchers
  if (!rows.length) {
    return null;
  }

  return (
    <TableContainer component={Paper} elevation={0}>
      <Table className="vouchers-table" padding="none">
        <TableHead>
          <TableRow>
            <TableCell>{t('components.discount-code-list.code')}</TableCell>
            <TableCell>{t('components.discount-code-list.discount')}</TableCell>
            <TableCell>{t('components.discount-code-list.status')}</TableCell>
            <TableCell />
          </TableRow>
        </TableHead>

        <TableBody>
          {rows.map((row) => (
            <TableRow key={row.code}>
              <TableCell component="td" scope="row">
                {row.code}
              </TableCell>
              <TableCell>{row.discount_type === 'sum' ? formatPrice(row.discount_amount) : +row.discount_amount + ' %'}</TableCell>
              <TableCell>
                <Switch checked={row.status === 'active'} onChange={() => onStatusChange(row)} name="status" color="primary" />
              </TableCell>
              <TableCell>
                <ConfirmationDialog message={t('pages.discount-codes.delete-message')} title={t('pages.discount-codes.delete-title')}>
                  <IconButton onClick={() => onDelete(row.id)}>
                    <DeleteIcon color="primary" />
                  </IconButton>
                </ConfirmationDialog>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default DiscountCodesTable;
